import { CadastroUsuario } from '../../../entity/CadastroUsuario';
import { Component, OnInit } from '@angular/core';
import { PesquisarUsuarioService } from '../../../service/usuario/pesquisar-usuario.service';
import { ResponseHandler } from '../../../entity/ResponseHandlerDTO';
import { EDITAR_USUARIO } from '../../../tools/URL';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { MSG_USUARIO_DESATIVADO, MSG_USUARIO_REATIVADO } from 'src/app/tools/Mensagens';

const SLASH = '/';
const MAX_PAGE = 5;

@Component({
  selector: 'pesquisar-usuario',
  templateUrl: './pesquisar-usuario.component.html',
  styleUrls: ['./pesquisar-usuario.component.css']
})
export class PesquisarUsuarioComponent implements OnInit {

  page = 0;
  count = 5;
  pages: Array<number>;
  usuario: CadastroUsuario = new CadastroUsuario();
  listUsuario = [];

  constructor(private pesquisarUsuarioService: PesquisarUsuarioService, private router: Router, public authService: AuthService) { }

  editarUsuario(idUsuario) {

    this.router.navigate([EDITAR_USUARIO + SLASH + idUsuario], idUsuario);

  }

  desativarUsuario(idUsuario): void {

    this.pesquisarUsuarioService.desativarPorOperador(idUsuario).subscribe(() => {

      alert(MSG_USUARIO_DESATIVADO);
      location.reload();

    });

  }

  reativarUsuario(idUsuario): void {

    this.pesquisarUsuarioService.reativarPorOperador(idUsuario).subscribe(() => {

      alert(MSG_USUARIO_REATIVADO);
      location.reload();

    });

  }


  ngOnInit() {
    this.findAll(this.usuario, this.page, this.count);
  }

  setNextPage(event: any) {
    event.preventDefault();
    if (this.page + 1 < this.pages.length) {
      this.page = this.page + 1;
      this.findAll(this.usuario, this.page, this.count);
    }
  }

  clean(event: any) {
    event.preventDefault();
    this.usuario = new CadastroUsuario();
    this.page = 0;
    this.count = 5;
    this.findAll(this.usuario, this.page, this.count);
  }

  filter(event: any) {
    event.preventDefault();
    this.page = 0;
    this.findAll(this.usuario, this.page, this.count);
  }

  sanitizeCpfCnpj(value: string) {
    this.usuario.cpfcnpj = (value || '').replace(/[^a-zA-Z0-9]/g, '');
  }

  exibePagina(index) {

    return (index < (this.page + MAX_PAGE) && (index >= this.page || index >= (this.pages.length - MAX_PAGE))) ||
            (MAX_PAGE > this.pages.length);

  }

  setFirstPage(event: any) {

    event.preventDefault();

    this.page = 0;
    this.findAll(this.usuario, this.page, this.count);

  }

  setLastPage(event: any) {

    event.preventDefault();

    this.page = this.pages.length - 1;

    this.findAll(this.usuario, this.page, this.count);

  }

  setPreviousPage(event: any) {
    event.preventDefault();
    if (this.page > 0) {
      this.page = this.page - 1;
      this.findAll(this.usuario, this.page, this.count);
    }
  }

  setPage(i, event: any) {
    event.preventDefault();
    this.page = i;
    this.findAll(this.usuario, this.page, this.count);
  }

  findAll(usuario: CadastroUsuario, page: number, count: number) {
    this.pesquisarUsuarioService.findAll(usuario, page, count).subscribe((responseHandler: ResponseHandler) => {
      this.listUsuario = responseHandler.data.content;
      this.pages = new Array(responseHandler.data.totalPages);
    });
  }

}
